import React from "react";

import { useNavigate } from "react-router-dom";

import logo from "../assets/logo.png";

function SplashScreen() {

  const navigate = useNavigate();

  setTimeout(() => {

    navigate("/login");

  }, 3000);

  return (

    <div className="splash-screen">

      <img
        src={logo}
        alt="logo"
        className="logo"
      />

      <h1>Farm Project</h1>

      <div className="loader"></div>

    </div>
  );
}

export default SplashScreen;